<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="角色名称：" prop="name">
            <el-input style="width: 424px;" v-model="ruleForm.name" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="管理权限：" prop="menuIdList">
            <el-tree
              :data="dataList"
              show-checkbox
              default-expand-all
              :check-strictly="checkStrictly"
              node-key="id"
              ref="tree"
              highlight-current
              :default-checked-keys="checkedKeysList"
              :props="defaultProps">
            </el-tree>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveRole, updateRole, fetchRoleDetailById, queryMenuTreeList } from '@/api/shop'
export default {
  name: 'ShopRoleAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      dataId: this.$route.query.dataId,
      dataList:[],
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      checkedKeysList:[],
      checkStrictly:true,
      ruleForm: {
        name: '',
        menuIdList:[],
        status: false
      },
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ],
        menuIdList: [
          { required: true, message: '请选择管理权限', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.treeInfoFun();
    if (this.$route.query.dataId != '') {
      let that = this
      fetchRoleDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.name = data.name
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.checkedKeysList = data.menuIdList;
          that.ruleForm.status = status
          setTimeout(function(){
            that.checkStrictly = false;
          },500);
        }
      })
    }else{
      this.checkStrictly = false;
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 获取树形结构系统菜单列表
    treeInfoFun(){
      var that = this;
      queryMenuTreeList().then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          that.dataList = data;
        }
      });
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let name = that.ruleForm.name
      let parentTreeId = this.$refs.tree.getHalfCheckedKeys()
      var treeList = that.$refs.tree.getCheckedNodes();
      let status = that.ruleForm.status ? 1 : 0
      var menuIdList = [];
      treeList.forEach(function(item){
        menuIdList.push(item.id);
      });
      // tree父级id,子集全选是，此父级数组为空
      parentTreeId.forEach(function(item){
        menuIdList.push(item);
      })
      if (name === '') {
        this.$message.error('请输入管理员名称')
        return false
      }
      if (menuIdList.length === 0) {
        this.$message.error('请选择管理权限')
        return false
      }
      let passData = {
        name: name, status: status, menuIdList: menuIdList
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateRole(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveRole(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/shop/role/RoleAdd.vue